var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmissionDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_4531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1313 0.73999H4.40135C2.73345 0.73999 1.38135 2.09209 1.38135 3.75999V18.24C1.38135 19.9079 2.73345 21.26 4.40135 21.26H14.1313C15.7992 21.26 17.1513 19.9079 17.1513 18.24V3.75999C17.1513 2.09209 15.7992 0.73999 14.1313 0.73999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32137 7.80004L4.15137 7.59004C7.11137 3.81004 11.2314 3.80004 14.2114 7.57004L14.3814 7.78004C11.4214 11.56 7.30137 11.57 4.32137 7.80004V7.80004Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26119 9.46989C10.2498 9.46989 11.0512 8.66848 11.0512 7.67989C11.0512 6.6913 10.2498 5.88989 9.26119 5.88989C8.2726 5.88989 7.47119 6.6913 7.47119 7.67989C7.47119 8.66848 8.2726 9.46989 9.26119 9.46989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52148 14.47H14.0115",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61133 17.54H10.7513",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_4531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.77,
    height: 21.52,
    fill: "white",
    transform: "translate(0.881348 0.23999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissionDashboard);
export default __webpack_public_path__ + "static/media/submission_dashboard.7405631e040da84f2079f774190de929.svg";
export { ForwardRef as ReactComponent };